import React, { useState, useEffect } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { IonRow, IonCol, IonBadge } from "@ionic/react";
import _ from "lodash";
import { CONSTANTS } from "../../constants";
import { utilService } from "../../services/utilService";
import TeamCreation from "../../components/Shared/TeamsCreationModal/TeamCreationModal";
import { doctorListInputData } from "../../components/Shared/DoctorList/doctor-list.model";
import { rolePermissionsService } from "../../services/rolePermissions.service";
import TeamsDoctorCard from "./TeamsDoctorCard";
import { StorageService } from "../../services/storage.service";
import { teamsListService } from "../Teams/teams.service";
import "./GlobalTeamAccordion.scss";

interface accordionProps {
  accordionList: any;
  selectScheduleData?: any;
  isFromTeams?: any;
  isFromUserCard?: boolean;
  userUnLinked?: any;
  editTeam?: any;
  isFromCaseHistoryDetails?: any;
  triggerTeammateList: any;
}

const GlobalTeamAccordion: React.FC<accordionProps> = (props) => {
  const [activeIndex, setActiveIndex]: any = useState(null);
  const [scheduleList, setScheduleList]: any = useState([]);
  const [doctorListInput, setDoctorListInput]: any = useState({});
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [selectScheduleData, setSelectScheduleData]: any = useState([]);
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [scheduleListItemToDelete, setScheduleListItemToDelete]: any = useState(
    []
  );
  const [teamJoinModal, enableTeamJoinModal] = useState(false);
  const [selectedTeamId, setSelectedTeamId]: any = useState();
  const [selectedTeamData, setSelectedTeamData]: any = useState();
  const [favouriteIcon, setFavouriteIcon]: any = useState(false);
  const [isLoaderActive, setLoaderStatus] = useState(false);

  useEffect(() => {
    if (props.accordionList) {
      setDoctorListInputData();
    }
  }, [props.accordionList]);

  useEffect(() => {
    if (!_.isEmpty(scheduleListItemToDelete)) {
      setIsShowAlert(true);
    }
  }, [scheduleListItemToDelete]);

  useEffect(() => {
    setSelectScheduleData(props.selectScheduleData);
  }, [props.selectScheduleData]);

  useEffect(() => {
    if (!_.isEmpty(scheduleList)) {
      // to open all accordions by default
      const scheduleIndexArray: any = [];
      scheduleList.forEach((scheduleListItem: any, index: any) => {
        scheduleIndexArray.push(index);
      });
      setActiveIndex(scheduleIndexArray);
    }
  }, [scheduleList]);

  const setFavourite = async (scheduleListItem: any) => {
    setFavouriteIcon((value: any) => !value);
    var favBoolValue = scheduleListItem?.favorite;
    const savePassword = utilService.getSavePasswordStatus();
    const userId = StorageService.getStorageItem(
      CONSTANTS.STORAGE[true === savePassword ? 1 : 0],
      "userId",
      true
    );

    let params: any = {
      team_id: scheduleListItem?.teamId,
      user_id: userId,
      favorite: favBoolValue,
    };
    const respTeammatesList = await teamsListService.getFavouriteTeamsList(
      params
    );
    if (respTeammatesList.isSuccess && respTeammatesList.result) {
      props.triggerTeammateList();
      setLoaderStatus(false);
      setActiveIndex(null);
    }
  };

  const setDoctorListInputData = () => {
    const doctorListInput: doctorListInputData = {
      componentName: CONSTANTS.COMPONENTS.HOME,
      isMultiSelectEnabled: false,
      isShowColorBadge: false,
    };
    setDoctorListInput(doctorListInput);
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
  };

  const setColSize = () => {
    if (props.isFromTeams && !props.isFromUserCard) {
      return "3";
    } else if (props.isFromUserCard) {
      return "6";
    } else {
      return "6";
    }
  };

  const updatedTeamList = (isSuccess: any) => {
    if (isSuccess) {
      props.triggerTeammateList();
    }
  };

  const joinToTeamModal = (selectedTeamData: any) => {
    enableTeamJoinModal(true);
    setSelectedTeamId(selectedTeamData.teamId);
    setSelectedTeamData(selectedTeamData);
  };

  return (
    <div className="accordion-wrapper">
      <Accordion
        multiple
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e?.index)}
      >
        {props?.accordionList?.map((scheduleListItem: any, index: any) => {
          return (
            <AccordionTab
              key={scheduleListItem.team_name}
              header={
                <React.Fragment>
                  <IonBadge className="accordian-badge-count">
                    {scheduleListItem.teammates.length}
                  </IonBadge>
                  <div
                    className={`add-users-to-team ${
                      props.isFromUserCard ? "hide-buttons" : ""
                    }`}
                    style={{
                      pointerEvents: scheduleListItem?.login_user_joined_team
                        ? "none"
                        : "auto",
                      opacity: scheduleListItem?.login_user_joined_team
                        ? 0.3
                        : 1,
                      cursor: scheduleListItem?.login_user_joined_team
                        ? "none"
                        : "pointer",
                    }}
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      joinToTeamModal(scheduleListItem);
                    }}
                  >
                    <span className="icon-add_users"></span>
                  </div>
                  <div
                    className={`fav-team ${
                      scheduleListItem.favorite === true
                        ? "input-icon icon-favorite_fill"
                        : "input-icon icon-favorite"
                    }`}
                    onClick={(e: any) => {
                      if (scheduleListItem.favorite == true) {
                        scheduleListItem.favorite = false;
                      } else {
                        scheduleListItem.favorite = true;
                      }
                      setFavourite(scheduleListItem);
                    }}
                  ></div>
                  <IonBadge
                    className="accordian-badge-count"
                    title="Number of providers on call"
                  >
                    {scheduleListItem.scheduleBadgeCount}
                  </IonBadge>
                  <span className="tab-header-value">
                    {scheduleListItem.team_name +
                      (scheduleListItem.site
                        ? `-${scheduleListItem.site}`
                        : "-No Site")}
                  </span>
                </React.Fragment>
              }
            >
              <div className="accordion-content-container">
                <IonRow>
                  {scheduleListItem?.teammates &&
                  !_.isEmpty(scheduleListItem?.teammates) ? (
                    scheduleListItem?.teammates?.map(
                      (item: any, index: any) => {
                        return (
                          <IonCol
                            size-lg={setColSize()}
                            size="12"
                            key={item.guid}
                          >
                            <TeamsDoctorCard
                              isFromGlobalTeamAccordion={true}
                              key={item.guid}
                              doctorData={item}
                              getSelectedCards={() => {}}
                              doctorListInputDetails={
                                scheduleListItem?.teammates
                              }
                              rolePermissions={rolePermissions}
                              isFromTeams={props.isFromTeams}
                              updateTeamList={updatedTeamList}
                              isFromUserCard={props.isFromUserCard}
                              teamID={scheduleListItem.team_name}
                              teamDetails={scheduleListItem}
                              isFromGlobalTeamSearch={true}
                            ></TeamsDoctorCard>
                          </IonCol>
                        );
                      }
                    )
                  ) : (
                    <div className="no-results-label">
                      No team mates available.
                    </div>
                  )}
                </IonRow>
              </div>
            </AccordionTab>
          );
        })}
      </Accordion>
      <TeamCreation
        showModal={teamJoinModal}
        teamId={selectedTeamId}
        teamDetails={selectedTeamData}
        fromAccordionUserCard={true}
        joinToTeam={teamJoinModal}
        updateTeamList={updatedTeamList}
        onOk={() => {
          enableTeamJoinModal(false);
        }}
        onCancel={() => {
          enableTeamJoinModal(false);
        }}
      ></TeamCreation>
    </div>
  );
};

export default GlobalTeamAccordion;
